<template lang="html">
    <section class="faceIDDemo">
        <div class="Vlt-card Vlt-article">

            <div class="Vlt-grid">
                <div class="Vlt-col Vlt-col--A-1of2">
                    <div class="Vlt-card" style="text-align: left;height:150px">
                        <label style=" font-size:20px"><b>Step 1: Upload customer's photo (jpg)</b></label><br /><br />
                        <input style="margin-left:60px" type="file" ref="file" v-on:change="handleFileUpload()" />
                        <button v-if="!isOnFileSubmitHidden" v-on:click="submitFile()"
                            class="Vlt-btn Vlt-btn--primary Vlt-btn--app">{{ submitLabel }}</button>
                        <svg v-if="!isOnFileSuccessHidden" data-v-497a0e1c="" class="Vlt-icon Vlt-green"
                            style="width:45px;height:45px">
                            <use data-v-497a0e1c="" xlink:href="#V_Vlt-icon-check-circle-negative"></use>
                        </svg>
                    </div>
                    <div v-if="!isVideoCallHidden" class="Vlt-card" style="height: 625px;text-align:left;">
                        <label style="font-size:20px"><b>Step 2: Start Video Call</b></label><br /><br />
                        <div id="subscriber"
                            style="width:100%;height:85%;background:#f7f5f1;position:relative;border: solid 2px">

                        </div>
                        <div id="publisher"
                            style="width:30%;height:30%;background:#efecec;z-index:100;right:25px;bottom:70px;position:absolute;border:solid 1px">

                        </div>
                        <div
                            style="text-align: center;width:100%;height:10%;background:black;z-index:101;position:inherit">
                            <button v-on:click="joinVideoSession()" v-if="!isCallBtnHidden"
                                style="background: black"><svg data-v-497a0e1c="" class="Vlt-icon Vlt-green"
                                    style="width:50px;height:50px">
                                    <use data-v-497a0e1c="" xlink:href="#V_Vlt-icon-call-outbound"></use>
                                </svg></button>
                            <button v-on:click="closeVideoSession()" v-if="!isHangupBtnHidden"
                                style="background: black"><svg data-v-497a0e1c="" class="Vlt-icon Vlt-green"
                                    style="width:50px;height:50px">
                                    <use data-v-497a0e1c="" xlink:href="#V_Vlt-icon-phone-down"></use>
                                </svg></button>
                            <button v-on:click="muteMic()" v-if="!isMiconBtnHidden" style="background: black"><svg
                                    data-v-497a0e1c="" class="Vlt-icon Vlt-green" style="width:50px;height:50px">
                                    <use data-v-497a0e1c="" xlink:href="#V_Vlt-icon-microphone"></use>
                                </svg></button>
                            <button v-on:click="unmuteMic()" v-if="!isMicoffBtnHidden" style="background: black"><svg
                                    data-v-497a0e1c="" class="Vlt-icon Vlt-green" style="width:50px;height:50px">
                                    <use data-v-497a0e1c="" xlink:href="#V_Vlt-icon-microphone-mute"></use>
                                </svg></button>
                        </div>
                    </div>
                </div>
                <div class="Vlt-col Vlt-col--A-2of2">
                    <div v-if="!isInviteHidden" class="Vlt-card" style="text-align: left;height:230px">
                        <label style="font-size:20px"><b>Step 3: Invite Customer</b></label><br />
                        <div style="text-align: center;">
                            <img
                                :src="'https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=https://freeconferencing.vonage.com/room/' + owner + '?skip=yes&l=v&mute=yes'" /><br />
                            <label
                                style="font-size: 14px; ">https://freeconferencing.vonage.com/room/{{ owner }}?skip=yes&l=v&mute=yes</label>
                        </div>
                    </div>
                    <div v-if="!isResultHidden" class="Vlt-card" style="height: 500px;text-align:left;">
                        <label style="font-size:20px"><b>Step 4: Do Face ID</b></label> <br /><br />
                        <div style="text-align: center;">
                            <button class="Vlt-btn Vlt-btn--primary Vlt-btn--large Vlt-btn--app"
                                v-on:click="sendScreenShot()">Verify</button>
                        </div>
                        <div class="Vlt-grid">
                            <div id="frame1" class="Vlt-col Vlt-col--A-1of2"
                                style="width:100%;height:300px;background: #efecec;text-align: center;">
                                <canvas style="width:100%;height:300px" ref="canvas1"></canvas>
                                <svg v-if="isShowFrames" data-v-497a0e1c="" class="Vlt-icon Vlt-black"
                                    style="position:absolute;right:0px;width:100%;height:300px">
                                    <use data-v-497a0e1c="" xlink:href="#V_Vlt-icon-user"></use>
                                </svg>
                            </div>
                            <div id="frame2" class="Vlt-col Vlt-col--A-2of2"
                                style="width:100%;height:300px;background: #efecec;text-align: center;">
                                <canvas style="width:100%;height:300px" ref="canvas2"></canvas>
                                <svg v-if="isShowFrames" data-v-497a0e1c="" class="Vlt-icon Vlt-black"
                                    style="position:absolute;right:0px;width:100%;height:300px">
                                    <use data-v-497a0e1c="" xlink:href="#V_Vlt-icon-user"></use>
                                </svg>
                            </div>
                        </div>
                        <div style="text-align: center;">
                            <label style="font-size: 30px" v-if="!isFaceIDSuccessHidden"> Match
                                <svg data-v-497a0e1c="" class="Vlt-icon Vlt-green" style="width:45px;height:45px">
                                    <use data-v-497a0e1c="" xlink:href="#V_Vlt-icon-check-circle-negative"></use>
                                </svg>
                            </label>
                            <label style="font-size: 30px" v-if="!isFaceIDFailHidden"> Didn't Match
                                <svg data-v-497a0e1c="" class="Vlt-icon Vlt-red" style="width:45px;height:45px">
                                    <use data-v-497a0e1c="" xlink:href="#V_Vlt-icon-cross-circle-negative"></use>
                                </svg>
                            </label>
                            <div v-if="!isFaceIDSpinnerHidden" class="Vlt-spinner"></div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script lang="js">
import OT from "@opentok/client";
import {
    $HTTPDEMO
} from '../services/nidsService.js';
import Pusher from "pusher-js";
import {
    parsePhoneNumberFromString
} from 'libphonenumber-js';

import {
    VltIcon,
    VltButton,
    VltCard,
    VltTab,
    VltGrid,
    VltCol,
    VltField,
    VltInput,

} from "@vonagevolta/vue";

export default {
    name: 'faceIDDemo',
    data() {
        return {
            message: 'Sending a text message is EASY!!!',
            submitLabel: 'Submit',
            number: '',
            prettyNumber: '',
            numberStuff: {},
            incoming: [],
            delivery: [],
            fromNumber: '',
            owner: '',
            file: '',
            sessionId: '',
            token: '',
            apiKey: '',
            session: null,
            fromNumber: '',
            subscriber: null,
            publisher: null,
            onfile: '',
            customer_file: '',
            isVideoCallHidden: true,
            isInviteHidden: true,
            isResultHidden: true,
            isCallBtnHidden: false,
            isMicoffBtnHidden: true,
            isHangupBtnHidden: true,
            isMiconBtnHidden: true,
            isOnFileSuccessHidden: true,
            isOnFileSubmitHidden: false,
            isFaceIDSpinnerHidden: true,
            isFaceIDSuccessHidden: true,
            isFaceIDFailHidden: true,
            isShowFrames: true,
            frame1src: '',
            frame2src: '',
        }
    },
    props: {
        nexmo: {
            type: Object,
            required: false
        }
    },
    methods: {
        sendText() {
            console.log("To " + this.number + " we send: " + this.message);
            $HTTPDEMO.post('smsDemo.php/send', {
                to: this.number,
                message: this.message
            });
            this.$swal('Success',
                'The Text Message has been sent to ' + this.numberStuff.formatInternational + '.',
                'success');
        },
        async register() {
            console.log("Registering the Demo Component with the associated backend");
            const {
                data
            } = await $HTTPDEMO.post('faceIDDemo.php/register', {});
            this.sessionId = data.sessionId;
            this.token = data.token;
            this.apiKey = data.apiKey
            this.gotToken = 1;
            console.log("Got SessionID=" + this.sessionId + " Token=" + this.token + ", apiKey:" + this.apiKey);

        },
        onUpdate(payload) {
            this.numberStuff = payload;
            if (payload.isValid) {
                this.number = this.numberStuff.formattedNumber.replace(/\D/g, '');;
            } else {
                var test = parsePhoneNumberFromString(payload.formattedNumber);
                console.log("Re-checked number: ", test)
                if (test.isValid()) {
                    this.isValid = true;
                    this.number = test.number.replace(/\D/g, '');
                    console.log("new this.number = ", this.number)
                } else {
                    this.isValid = false;
                }
            }
        },
        handleFileUpload() {
            this.file = this.$refs.file.files[0];
        },
        async submitFile() {
            try {
                this.submitLabel = "Wait.."
                let formData = new FormData();
                formData.append('onfile', this.file);
                let res = await $HTTPDEMO.post('/faceIDDemo.php',
                    formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }

                }
                );
                console.log(res.data);
                if (res.data.status != "success") {
                    alert("Error uploading the file");
                    this.submitLabel = "Submit";
                } else {
                    this.onfile = res.data.filename;
                    this.isVideoCallHidden = false;
                    this.isOnFileSuccessHidden = false;
                    this.isOnFileSubmitHidden = true;
                }
            } catch (error) {
                console.log(error);
                alert("error while posting file");
                this.submitLabel = "Submit";
            }

        },
        b64toBlob(b64Data, contentType, sliceSize) {
            contentType = contentType || '';
            sliceSize = sliceSize || 512;

            var byteCharacters = atob(b64Data);
            var byteArrays = [];

            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);

                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);

                byteArrays.push(byteArray);
            }

            var blob = new Blob(byteArrays, {
                type: contentType
            });
            return blob;
        },
        async sendScreenShot() {

            this.isFaceIDSpinnerHidden = false;
            this.isFaceIDFailHidden = true;
            this.isFaceIDSuccessHidden = true;

            var imgdata = undefined;
            if (subscriber) {
                imgdata = this.subscriber.getImgData();
            }
            if (imgdata != undefined) {
                try {
                    var blob = this.b64toBlob(imgdata, "image/png");
                    let formData = new FormData();
                    formData.append('customer', blob);
                    let res = await $HTTPDEMO.post('/faceIDDemo.php',
                        formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }

                    }
                    );
                    console.log(res.data);
                    if (res.data.status != "success") {
                        alert("Error uploading the file");
                    } else {
                        this.customer_file = res.data.filename;
                        this.doFaceID();
                    }
                } catch (error) {
                    alert("error posting screenshot");
                    console.log(error);
                }
            }
        },
        async doFaceID() {

            try {
                let res = await $HTTPDEMO.get("/faceIDDemo.php/identify?onfile=" + this.onfile + "&customer_file=" + this.customer_file);
                //let res = await $HTTPDEMO.get("/faceIDDemo.php/identify?onfile=YtVwOllF.jpg&customer_file=IrqbejP.png");
                console.log(res);
                if (!res.data || (typeof res.data === 'string')) {
                    this.isFaceIDSpinnerHidden = true;
                    this.isFaceIDFailHidden = false;
                    this.isFaceIDSuccessHidden = true;
                } else {
                    if (res.data.result.isIdentical == true) {
                        this.isFaceIDSpinnerHidden = true;
                        this.isFaceIDFailHidden = true;
                        this.isFaceIDSuccessHidden = false;
                    } else if (res.data.result.isIdentical == false) {
                        this.isFaceIDSpinnerHidden = true;
                        this.isFaceIDFailHidden = false;
                        this.isFaceIDSuccessHidden = true;
                    }
                    this.isShowFrames = false;
                    this.frame1src = res.data.frame1;
                    this.frame2src = res.data.frame2;
                    this.drawCanvas(res.data.face1.faceRectangle, this.frame1src, this.$refs.canvas1);
                    this.drawCanvas(res.data.face2.faceRectangle, this.frame2src, this.$refs.canvas2);
                }
            } catch (error) {
                this.isFaceIDSpinnerHidden = true;
                this.isFaceIDFailHidden = false;
                this.isFaceIDSuccessHidden = true;
                alert("Error while performing FaceID");
                console.log(error);
            }
        },
        drawCanvas(xy, url, canvas) {
            console.log(this.$refs);
            var ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            var imagePaper1 = new Image();
            var self = this;
            imagePaper1.onload = function () {
                ctx.drawImage(imagePaper1, 0, 0, 300, 150);
                var xratio = imagePaper1.naturalWidth / 300;
                var yratio = imagePaper1.naturalHeight / 150;
                var x = Math.round(xy.left / xratio);
                var y = Math.round(xy.top / yratio);
                var width = Math.round(xy.width / xratio);
                var height = Math.round(xy.height / yratio);
                ctx.beginPath();
                ctx.rect(x, y, width, height);
                ctx.strokeStyle = "red";
                ctx.lineWidth = 3;
                ctx.stroke();
                console.log(imagePaper1.naturalWidth);
            };
            imagePaper1.src = url;
            imagePaper1.width = "300px";
            imagePaper1.height = "300px";
            console.log(url);
        },
        joinVideoSession() {
            this.session = OT.initSession(this.apiKey, this.sessionId);
            this.session.connect(this.token, err => {
                if (err) {
                    errorHandler(err);
                } else {
                    var elem = document.getElementById("publisher");
                    this.publisher = OT.initPublisher(elem, {
                        insertMode: 'append',
                        width: '100%',
                        height: '100%'
                    }, err => {
                        if (err) {
                            this.$emit("error", err);
                        } else {
                            this.$emit("publisherCompleted");
                            this.session.publish(this.publisher, err => {
                                if (err) {
                                    this.$emit("error", err);
                                } else {
                                    this.$emit("publisherConnected", this.publisher);
                                    this.isHangupBtnHidden = false;
                                    this.isCallBtnHidden = true;
                                    this.isMicoffBtnHidden = true;
                                    this.isMiconBtnHidden = false;
                                    this.isInviteHidden = false;
                                }
                            });
                        }
                    });
                }
            });
            this.session.on("streamCreated", event => {
                this.subscriber = this.session.subscribe(event.stream,
                    'subscriber', {
                    insertMode: 'append',
                    width: '100%',
                    height: '100%'
                },
                    function (error) {
                        if (error) {
                            console.log(error);
                        } else {
                            console.log('Subscriber added.');

                        }
                    });
                this.isResultHidden = false;
            });
            this.session.on("streamDestroyed", event => {

            });

        },
        closeVideoSession() {
            this.session.disconnect();
            this.isHangupBtnHidden = true;
            this.isCallBtnHidden = false;
            this.isMicoffBtnHidden = true;
            this.isMiconBtnHidden = true;
        },
        muteMic() {
            this.publisher.publishAudio(false);
            this.isMicoffBtnHidden = false;
            this.isMiconBtnHidden = true;
        },
        unmuteMic() {
            this.publisher.publishAudio(true);
            this.isMicoffBtnHidden = true;
            this.isMiconBtnHidden = false;
        },

    },
    components: {
        "vlt-icon": VltIcon,
        "vlt-button": VltButton,
        "vlt-field": VltField,
        "vlt-input": VltInput,
    },
    created() {
        this.register();
        this.fromNumber = this.nexmo['from'];
        this.owner = this.nexmo['phone'];
        this.prettyNumber = parsePhoneNumberFromString("+" + this.nexmo['phone']).formatNational();

    },
    beforeDestroy() {
        if (this.session) {
            this.session.disconnect();
        }
    },
}
</script>

<style scoped lang="scss"></style>
